"use client";

import { c as _c } from "react/compiler-runtime";
import Footer from "@/components/footer/Footer";
import { HOME_TAB_EVENT, getStoredHomeTab, type HomeTab } from "@/components/home/useHomeTabs";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import useDeviceInfo from "./hooks/useDeviceInfo";
const HOME_TAB_QUERY_PARAM = "tab";
const isHomeTab = (value: unknown): value is HomeTab => value === "feed" || value === "latest";
export default function FooterWrapper() {
  const $ = _c(3);
  const {
    isApp
  } = useDeviceInfo();
  const pathname = usePathname();
  const [homeActiveTab, setHomeActiveTab] = useState(_temp);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const win = (globalThis as typeof globalThis & {
        window?: Window | undefined;
      }).window;
      if (win === undefined) {
        return;
      }
      const params = new URLSearchParams(win.location?.search ?? "");
      const tabFromQuery = params.get(HOME_TAB_QUERY_PARAM);
      const nextTab = isHomeTab(tabFromQuery) ? tabFromQuery : getStoredHomeTab();
      setHomeActiveTab(current => current === nextTab ? current : nextTab);
      const handleTabChange = event => {
        const detail = event.detail;
        if (!detail?.tab || !isHomeTab(detail.tab)) {
          return;
        }
        setHomeActiveTab(detail.tab);
      };
      win.addEventListener(HOME_TAB_EVENT, handleTabChange as EventListener);
      return () => {
        win.removeEventListener(HOME_TAB_EVENT, handleTabChange as EventListener);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const homeFeedTabActive = pathname === "/" && homeActiveTab === "feed";
  const myFeedRoutes = ["/my-feed", "/feed"];
  const hideFooter = isApp || homeFeedTabActive || myFeedRoutes.some(path_0 => pathname?.startsWith(path_0)) || ["/waves", "/messages", "/notifications", "/open-mobile"].some(path => pathname?.startsWith(path));
  if (hideFooter) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Footer />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp() {
  return getStoredHomeTab();
}